import { render, staticRenderFns } from "./OverAllTransactions.vue?vue&type=template&id=5630ab2a&scoped=true"
import script from "./OverAllTransactions.vue?vue&type=script&lang=js"
export * from "./OverAllTransactions.vue?vue&type=script&lang=js"
import style0 from "./OverAllTransactions.vue?vue&type=style&index=0&id=5630ab2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630ab2a",
  null
  
)

export default component.exports